export enum DataHeaderCloseAction {
    CANCEL = "cancel",
    DELETE = "delete",
    EXECUTE = "execute"
}
